import ErrorTemplate from './ErrorTemplate'
import { useDispatch } from 'react-redux'
import React, { useEffect } from 'react'
import { setPageName } from '../../redux'

function NotFound() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setPageName('404'))
  }, [])

  return <ErrorTemplate error_code={404} />
}

export default React.memo(NotFound)
